<template>
  <div class="min-h-screen bg-gray-50 py-12">
    <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <!-- Breadcrumb -->
      <nav class="mb-8">
        <ol class="flex flex-wrap items-center space-x-2 text-sm text-gray-500">
          <li><router-link to="/" class="hover:text-blue-600">Trang chủ</router-link></li>
          <li>/</li>
          <li><router-link to="/blog" class="hover:text-blue-600">Blog</router-link></li>
          <li>/</li>
          <li class="text-gray-900">VPN vs Proxy vs Tor</li>
        </ol>
      </nav>

      <!-- Article Header -->
      <header class="mb-8">
        <h1 class="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4">So sánh VPN vs Proxy vs Tor: Công nghệ bảo mật nào phù hợp với bạn? (2025)</h1>
        <div class="flex items-center text-sm text-gray-500 mb-6">
          <span>—</span>
          <span class="mx-2">•</span>
          <span>8 phút đọc</span>
          <span class="mx-2">•</span>
          <span>Bảo mật & Quyền riêng tư</span>
        </div>
        <div class="h-48 sm:h-56 lg:h-64 bg-gradient-to-br from-indigo-500 to-fuchsia-600 rounded-lg flex items-center justify-center">
          <svg class="w-16 h-16 sm:w-20 sm:h-20 lg:w-24 lg:h-24 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
        </div>
      </header>

      <!-- Article Content -->
      <article class="bg-white rounded-lg shadow-lg p-4 sm:p-6 lg:p-8">
        <div class="prose prose-lg max-w-none">
          <h2>VPN, Proxy, Tor là gì và tại sao cần thiết?</h2>
          <p>Trong thời đại số, bảo vệ quyền riêng tư trực tuyến trở nên quan trọng hơn bao giờ hết. VPN, Proxy và Tor là 3 công nghệ bảo mật phổ biến nhất, mỗi loại có ưu nhược điểm riêng.</p>
          
          <div class="bg-blue-50 p-4 sm:p-6 rounded-lg my-6">
            <h3 class="text-xl font-semibold mb-4 text-blue-800">🔒 Tại sao cần bảo vệ quyền riêng tư?</h3>
            <ul class="space-y-2 text-blue-700">
              <li>• <strong>ISP theo dõi:</strong> Nhà cung cấp internet có thể theo dõi hoạt động</li>
              <li>• <strong>Chính phủ giám sát:</strong> Các chương trình giám sát hàng loạt</li>
              <li>• <strong>Hacker tấn công:</strong> Mạng WiFi công cộng không an toàn</li>
              <li>• <strong>Tracking quảng cáo:</strong> Thu thập dữ liệu cá nhân</li>
              <li>• <strong>Geographic restrictions:</strong> Hạn chế nội dung theo vùng</li>
            </ul>
          </div>

          <h2>1. VPN (Virtual Private Network)</h2>
          <div class="bg-green-50 p-4 sm:p-6 rounded-lg my-6">
            <h3 class="font-semibold mb-4 text-green-800">🛡️ VPN là gì?</h3>
            <p>VPN tạo ra một "đường hầm" mã hóa giữa thiết bị của bạn và server VPN, bảo vệ toàn bộ traffic internet.</p>
          </div>

          <h3>Ưu điểm của VPN:</h3>
          <div class="bg-gray-50 p-4 sm:p-6 rounded-lg my-6">
            <ul class="space-y-2 text-gray-700">
              <li>• <strong>Mã hóa toàn bộ:</strong> Bảo vệ tất cả traffic, không chỉ browser</li>
              <li>• <strong>Tốc độ ổn định:</strong> Thường nhanh hơn Tor</li>
              <li>• <strong>Dễ sử dụng:</strong> Chỉ cần cài app và kết nối</li>
              <li>• <strong>Server toàn cầu:</strong> Chọn server ở nhiều quốc gia</li>
              <li>• <strong>Streaming support:</strong> Truy cập Netflix, YouTube từ mọi nơi</li>
              <li>• <strong>Kill switch:</strong> Tự động ngắt kết nối khi VPN bị lỗi</li>
            </ul>
          </div>

          <h3>Nhược điểm của VPN:</h3>
          <div class="bg-red-50 p-4 sm:p-6 rounded-lg my-6">
            <ul class="space-y-2 text-red-700">
              <li>• <strong>Chi phí:</strong> VPN tốt thường có phí</li>
              <li>• <strong>Trust provider:</strong> Phải tin tưởng nhà cung cấp VPN</li>
              <li>• <strong>Logs policy:</strong> Một số VPN có thể log dữ liệu</li>
              <li>• <strong>Single point of failure:</strong> Nếu server bị hack, dữ liệu lộ</li>
              <li>• <strong>Government pressure:</strong> Có thể bị yêu cầu cung cấp dữ liệu</li>
            </ul>
          </div>

          <h2>2. Proxy Server</h2>
          <div class="bg-yellow-50 p-4 sm:p-6 rounded-lg my-6">
            <h3 class="font-semibold mb-4 text-yellow-800">🔄 Proxy là gì?</h3>
            <p>Proxy hoạt động như "người trung gian" giữa bạn và internet, thay đổi IP address nhưng thường không mã hóa traffic.</p>
          </div>

          <h3>Các loại Proxy:</h3>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4 my-6">
            <div class="bg-white p-4 rounded-lg border">
              <h4 class="font-semibold text-blue-600 mb-2">HTTP Proxy</h4>
              <ul class="text-sm space-y-1 text-gray-600">
                <li>• Chỉ hoạt động với HTTP/HTTPS</li>
                <li>• Không mã hóa traffic</li>
                <li>• Dễ cài đặt</li>
                <li>• Tốc độ nhanh</li>
              </ul>
            </div>
            <div class="bg-white p-4 rounded-lg border">
              <h4 class="font-semibold text-green-600 mb-2">SOCKS Proxy</h4>
              <ul class="text-sm space-y-1 text-gray-600">
                <li>• Hỗ trợ nhiều protocol</li>
                <li>• SOCKS4/SOCKS5</li>
                <li>• Tốc độ trung bình</li>
                <li>• Linh hoạt hơn HTTP</li>
              </ul>
            </div>
          </div>

          <h3>Ưu điểm của Proxy:</h3>
          <div class="bg-gray-50 p-4 sm:p-6 rounded-lg my-6">
            <ul class="space-y-2 text-gray-700">
              <li>• <strong>Miễn phí:</strong> Nhiều proxy miễn phí</li>
              <li>• <strong>Tốc độ cao:</strong> Ít overhead hơn VPN</li>
              <li>• <strong>Đơn giản:</strong> Dễ cấu hình</li>
              <li>• <strong>Bypass geo-block:</strong> Truy cập nội dung bị chặn</li>
              <li>• <strong>Web scraping:</strong> Tốt cho automation</li>
            </ul>
          </div>

          <h3>Nhược điểm của Proxy:</h3>
          <div class="bg-red-50 p-4 sm:p-6 rounded-lg my-6">
            <ul class="space-y-2 text-red-700">
              <li>• <strong>Không mã hóa:</strong> Traffic có thể bị đọc</li>
              <li>• <strong>Không bảo vệ toàn bộ:</strong> Chỉ hoạt động với app hỗ trợ</li>
              <li>• <strong>Không ổn định:</strong> Proxy miễn phí thường chậm/chết</li>
              <li>• <strong>Logs:</strong> Proxy có thể log dữ liệu</li>
              <li>• <strong>Malware risk:</strong> Proxy độc hại có thể chèn malware</li>
            </ul>
          </div>

          <h2>3. Tor (The Onion Router)</h2>
          <div class="bg-purple-50 p-4 sm:p-6 rounded-lg my-6">
            <h3 class="font-semibold mb-4 text-purple-800">🧅 Tor là gì?</h3>
            <p>Tor sử dụng mạng lưới các node tự nguyện để định tuyến traffic qua nhiều lớp, đảm bảo ẩn danh tối đa.</p>
          </div>

          <h3>Cách hoạt động của Tor:</h3>
          <div class="bg-gray-50 p-4 sm:p-6 rounded-lg my-6">
            <ol class="space-y-3 text-gray-700">
              <li><strong>1. Entry Node:</strong> Kết nối đầu tiên (ISP có thể thấy)</li>
              <li><strong>2. Middle Node:</strong> Node trung gian (không biết nguồn/đích)</li>
              <li><strong>3. Exit Node:</strong> Node cuối cùng (có thể thấy đích)</li>
              <li><strong>4. Onion Routing:</strong> Mỗi node chỉ biết node trước/sau</li>
            </ol>
          </div>

          <h3>Ưu điểm của Tor:</h3>
          <div class="bg-gray-50 p-4 sm:p-6 rounded-lg my-6">
            <ul class="space-y-2 text-gray-700">
              <li>• <strong>Ẩn danh cao:</strong> Khó truy vết nhất</li>
              <li>• <strong>Miễn phí:</strong> Hoàn toàn miễn phí</li>
              <li>• <strong>Decentralized:</strong> Không có server trung tâm</li>
              <li>• <strong>Open source:</strong> Code công khai, có thể audit</li>
              <li>• <strong>Access .onion sites:</strong> Dark web sites</li>
              <li>• <strong>Government resistance:</strong> Khó bị chính phủ kiểm soát</li>
            </ul>
          </div>

          <h3>Nhược điểm của Tor:</h3>
          <div class="bg-red-50 p-4 sm:p-6 rounded-lg my-6">
            <ul class="space-y-2 text-red-700">
              <li>• <strong>Tốc độ chậm:</strong> Rất chậm do nhiều lớp</li>
              <li>• <strong>Không phù hợp streaming:</strong> Video/audio bị lag</li>
              <li>• <strong>Exit node risk:</strong> Exit node có thể đọc traffic</li>
              <li>• <strong>Blocked by sites:</strong> Nhiều site chặn Tor</li>
              <li>• <strong>Complex setup:</strong> Khó cấu hình cho người mới</li>
              <li>• <strong>Legal issues:</strong> Bị cấm ở một số quốc gia</li>
            </ul>
          </div>

          <h2>4. So sánh chi tiết</h2>
          <div class="bg-blue-50 p-4 sm:p-6 rounded-lg my-6">
            <h3 class="font-semibold mb-4 text-blue-800">📊 Bảng so sánh tổng quan</h3>
            <div class="overflow-x-auto -mx-4 sm:mx-0">
              <table class="w-full text-xs sm:text-sm min-w-full">
                <thead>
                  <tr class="bg-gray-100">
                    <th class="p-2 sm:p-3 text-left">Tiêu chí</th>
                    <th class="p-2 sm:p-3 text-center">Proxy</th>
                    <th class="p-2 sm:p-3 text-center">VPN</th>
                    <th class="p-2 sm:p-3 text-center">Tor</th>
                  </tr>
                </thead>
                <tbody class="divide-y">
                  <tr>
                    <td class="p-2 sm:p-3 font-medium">Mã hóa</td>
                    <td class="p-2 sm:p-3 text-center text-red-600">Thường không</td>
                    <td class="p-2 sm:p-3 text-center text-green-600">Có (AES-256)</td>
                    <td class="p-2 sm:p-3 text-center text-green-600">Nhiều lớp</td>
                  </tr>
                  <tr>
                    <td class="p-2 sm:p-3 font-medium">Tốc độ</td>
                    <td class="p-2 sm:p-3 text-center text-green-600">Nhanh</td>
                    <td class="p-2 sm:p-3 text-center text-yellow-600">Trung bình</td>
                    <td class="p-2 sm:p-3 text-center text-red-600">Chậm</td>
                  </tr>
                  <tr>
                    <td class="p-2 sm:p-3 font-medium">Ẩn danh</td>
                    <td class="p-2 sm:p-3 text-center text-red-600">Thấp</td>
                    <td class="p-2 sm:p-3 text-center text-yellow-600">Trung bình</td>
                    <td class="p-2 sm:p-3 text-center text-green-600">Cao</td>
                  </tr>
                  <tr>
                    <td class="p-2 sm:p-3 font-medium">Chi phí</td>
                    <td class="p-2 sm:p-3 text-center text-green-600">Miễn phí</td>
                    <td class="p-2 sm:p-3 text-center text-yellow-600">Có phí</td>
                    <td class="p-2 sm:p-3 text-center text-green-600">Miễn phí</td>
                  </tr>
                  <tr>
                    <td class="p-2 sm:p-3 font-medium">Dễ sử dụng</td>
                    <td class="p-2 sm:p-3 text-center text-yellow-600">Trung bình</td>
                    <td class="p-2 sm:p-3 text-center text-green-600">Dễ</td>
                    <td class="p-2 sm:p-3 text-center text-red-600">Khó</td>
                  </tr>
                  <tr>
                    <td class="p-2 sm:p-3 font-medium">Bảo vệ toàn bộ</td>
                    <td class="p-2 sm:p-3 text-center text-red-600">Không</td>
                    <td class="p-2 sm:p-3 text-center text-green-600">Có</td>
                    <td class="p-2 sm:p-3 text-center text-yellow-600">Browser only</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <h2>5. Khi nào nên dùng gì?</h2>
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 my-8">
            <div class="bg-green-50 p-6 rounded-lg">
              <h3 class="font-semibold text-green-800 mb-4">🛡️ Dùng VPN khi:</h3>
              <ul class="space-y-2 text-green-700 text-sm">
                <li>• Sử dụng WiFi công cộng</li>
                <li>• Làm việc từ xa</li>
                <li>• Xem Netflix/streaming</li>
                <li>• Bypass geo-blocking</li>
                <li>• Bảo vệ toàn bộ thiết bị</li>
                <li>• Cần tốc độ ổn định</li>
              </ul>
            </div>
            
            <div class="bg-yellow-50 p-6 rounded-lg">
              <h3 class="font-semibold text-yellow-800 mb-4">🔄 Dùng Proxy khi:</h3>
              <ul class="space-y-2 text-yellow-700 text-sm">
                <li>• Web scraping</li>
                <li>• Bypass IP ban</li>
                <li>• Test ứng dụng</li>
                <li>• Cần tốc độ cao</li>
                <li>• Automation tasks</li>
                <li>• Không cần mã hóa mạnh</li>
              </ul>
            </div>
            
            <div class="bg-purple-50 p-6 rounded-lg">
              <h3 class="font-semibold text-purple-800 mb-4">🧅 Dùng Tor khi:</h3>
              <ul class="space-y-2 text-purple-700 text-sm">
                <li>• Cần ẩn danh tối đa</li>
                <li>• Truy cập dark web</li>
                <li>• Bypass censorship</li>
                <li>• Whistleblowing</li>
                <li>• Journalist activities</li>
                <li>• Không quan tâm tốc độ</li>
              </ul>
            </div>
          </div>

          <h2>6. Kết hợp các công nghệ</h2>
          <div class="bg-indigo-50 p-6 rounded-lg my-6">
            <h3 class="font-semibold mb-4 text-indigo-800">🔗 Advanced Combinations</h3>
            <div class="space-y-4">
              <div class="bg-white p-4 rounded-lg">
                <h4 class="font-semibold text-indigo-600 mb-2">VPN + Tor (VPN over Tor)</h4>
                <p class="text-sm text-gray-600">Kết nối VPN trước, sau đó dùng Tor. Bảo vệ khỏi ISP và tăng ẩn danh.</p>
              </div>
              
              <div class="bg-white p-4 rounded-lg">
                <h4 class="font-semibold text-blue-600 mb-2">Tor + VPN (Tor over VPN)</h4>
                <p class="text-sm text-gray-600">Kết nối VPN trước, sau đó dùng Tor. Bảo vệ khỏi entry node.</p>
              </div>
              
              <div class="bg-white p-4 rounded-lg">
                <h4 class="font-semibold text-green-600 mb-2">Proxy + VPN</h4>
                <p class="text-sm text-gray-600">Dùng proxy để thay đổi IP, sau đó kết nối VPN để mã hóa.</p>
              </div>
            </div>
          </div>

          <h2>7. Best Practices</h2>
          <div class="bg-gray-50 p-4 sm:p-6 rounded-lg my-6">
            <h3 class="font-semibold mb-4">💡 Lời khuyên bảo mật</h3>
            <ul class="space-y-2 text-gray-700">
              <li>• <strong>Không dùng miễn phí:</strong> VPN/Proxy miễn phí thường có rủi ro</li>
              <li>• <strong>Kiểm tra logs policy:</strong> Chọn provider không log</li>
              <li>• <strong>Kill switch:</strong> Luôn bật kill switch</li>
              <li>• <strong>DNS leak protection:</strong> Kiểm tra DNS không bị leak</li>
              <li>• <strong>Regular updates:</strong> Cập nhật software thường xuyên</li>
              <li>• <strong>Multiple layers:</strong> Kết hợp nhiều lớp bảo mật</li>
            </ul>
          </div>

          <h2>8. Công cụ kiểm tra bảo mật</h2>
          <div class="bg-blue-50 p-4 sm:p-6 rounded-lg my-6">
            <h3 class="font-semibold mb-4 text-blue-800">🔍 Test Tools</h3>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="bg-white p-4 rounded-lg">
                <h4 class="font-semibold text-blue-600 mb-2">IP Leak Tests</h4>
                <ul class="text-sm space-y-1">
                  <li>• <a href="https://ipleak.net" class="text-blue-600 underline">ipleak.net</a></li>
                  <li>• <a href="https://dnsleaktest.com" class="text-blue-600 underline">dnsleaktest.com</a></li>
                  <li>• <a href="https://whatismyip.com" class="text-blue-600 underline">whatismyip.com</a></li>
                </ul>
              </div>
              <div class="bg-white p-4 rounded-lg">
                <h4 class="font-semibold text-green-600 mb-2">Speed Tests</h4>
                <ul class="text-sm space-y-1">
                  <li>• <a href="https://fast.com" class="text-blue-600 underline">fast.com</a></li>
                  <li>• <a href="https://speedtest.net" class="text-blue-600 underline">speedtest.net</a></li>
                  <li>• <a href="https://testmy.net" class="text-blue-600 underline">testmy.net</a></li>
                </ul>
              </div>
            </div>
          </div>

          <div class="bg-green-50 p-6 rounded-lg mt-8">
            <h3 class="font-semibold mb-3 text-green-800">🎯 Kết luận</h3>
            <p class="text-sm text-green-700">Không có giải pháp nào hoàn hảo. Chọn công nghệ phù hợp với nhu cầu: VPN cho bảo mật hàng ngày, Proxy cho tốc độ, Tor cho ẩn danh tối đa. Kết hợp nhiều lớp bảo mật để đạt hiệu quả cao nhất.</p>
          </div>
        </div>
      </article>

      <!-- Back Button -->
      <div class="mt-8 text-center">
        <router-link 
          to="/blog" 
          class="inline-flex items-center px-4 sm:px-6 py-2 sm:py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors duration-200 text-sm sm:text-base"
        >
          <svg class="mr-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
          </svg>
          Quay lại Blog
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useHead } from '@vueuse/head'
const title = 'So sánh VPN vs Proxy vs Tor: Công nghệ bảo mật nào phù hợp với bạn? (2025)'
const desc  = 'So sánh chi tiết VPN, Proxy và Tor: ưu nhược điểm, khi nào nên dùng, cách kết hợp để bảo vệ quyền riêng tư tối đa'
const url   = 'https://webservices.vn/blog/vpn-vs-proxy-vs-tor-2025'

useHead({
  title,
  meta: [
    { name: 'description', content: desc },
    { property: 'og:type', content: 'article' },
    { property: 'og:title', content: title },
    { property: 'og:description', content: desc },
    { property: 'og:url', content: url },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: title },
    { name: 'twitter:description', content: desc }
  ],
  link: [{ rel: 'canonical', href: url }]
})
</script>
